export enum ogyTrackingEvent {
  OCS_LOADED = 'OCS_loaded'
}

type ExposureChangeCallback = (exposure: number) => void;
type IsViewableCallback = (isViewable: boolean) => void;

export class AdContainer {
  private onExposureChangePointer:
    | ExposureChangeCallback
    | IsViewableCallback
    | undefined;

  constructor(private aWindow: Window) {}

  public open(url: string) {
    if (this.aWindow.mraid && this.aWindow.mraid.open) {
      this.aWindow.mraid.open(url);
      return;
    }

    this.aWindow.open(url, '_blank');
  }

  public unload() {
    if (this.getMraidVersion() >= 3 && this.aWindow.mraid.unload) {
      this.aWindow.mraid.unload();
    } else {
      this.aWindow.mraid.close();
    }
  }

  public getMaxSize(): { width: number; height: number } | null {
    if (
      this.aWindow.mraid &&
      this.aWindow.mraid.getMaxSize &&
      typeof this.aWindow.mraid.getMaxSize === 'function'
    ) {
      const size = this.aWindow.mraid.getMaxSize();
      return { width: size.width, height: size.height };
    }

    return null;
  }

  public ogySendTrackingEvent(
    event: ogyTrackingEvent,
    parameters?: Record<string, any>
  ) {
    if (
      this.aWindow?.mraid?.ogySendTrackingEvent &&
      typeof this.aWindow.mraid.ogySendTrackingEvent === 'function'
    ) {
      (this.aWindow as any).mraid.ogySendTrackingEvent(event, parameters);
    }
  }

  public detachExposureChangedListener(): void {
    if (!this.aWindow.mraid) {
      return;
    }

    this.onExposureChangePointer &&
      (this.aWindow.mraid.removeEventListener as any)(
        'exposureChange',
        this.onExposureChangePointer
      );
    this.onExposureChangePointer &&
      (this.aWindow.mraid.removeEventListener as any)(
        'viewableChange',
        this.onExposureChangePointer
      );
  }

  public onExposureChanged(exposureCallback: ExposureChangeCallback): void {
    if (!this.aWindow.mraid) {
      return;
    }
    if (this.getMraidVersion() >= 3) {
      this.onExposureChangePointer = exposureCallback;
      this.aWindow.mraid.addEventListener(
        'exposureChange',
        this.onExposureChangePointer
      );
    } else {
      this.onExposureChangePointer = (isViewable: boolean) => {
        exposureCallback(isViewable ? 100 : 0);
      };
      this.aWindow.mraid.addEventListener(
        'viewableChange',
        this.onExposureChangePointer
      );
    }
  }

  private getMraidVersion() {
    return parseFloat(this.aWindow.mraid.getVersion());
  }
}
